// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"cW","shareText":"cX","show":"cY"};